import { Bar } from 'react-chartjs-2';
import { getBarColors, METRIC_LABELS, METRIC_MAX, PRIMARY_COLOR, INVERSE_METRICS } from './StatsHelpers';

const MetricBar = ({ metric, entries, filteredNames = new Set() }) => {
  const sorted = entries
    .filter(e => e[metric] != null)
    .sort((a, b) => INVERSE_METRICS.has(metric) ? a[metric] - b[metric] : b[metric] - a[metric]);

  if (sorted.length === 0) return null;

  const label = METRIC_LABELS[metric] || metric;
  const values = sorted.map(d => d[metric]);
  const max = METRIC_MAX[metric] || Math.max(...values, 1);
  const minVal = Math.min(...values);
  const xMin = minVal < 0 ? minVal : 0;
  const hasFilter = filteredNames.size > 0;

  return (
    <div className="tw-mb-3">
      <p className="tw-text-sm tw-font-medium tw-m-0 tw-mb-1">{label}</p>
      <div style={{ height: Math.max(100, sorted.length * 48) }}>
        <Bar
          data={{
            labels: sorted.map(d => d.name),
            datasets: [{
              data: sorted.map(d => d[metric]),
              backgroundColor: getBarColors(sorted.map(d => d[metric]), metric),
              borderRadius: 3,
              barThickness: 22,
            }]
          }}
          options={{
            responsive: true,
            maintainAspectRatio: false,
            indexAxis: 'y',
            plugins: {
              legend: { display: false },
              tooltip: {
                callbacks: {
                  label: (ctx) => `${label}: ${ctx.raw}`
                }
              }
            },
            scales: {
              x: { min: xMin, max, ticks: { font: { size: 12 } }, grid: { display: false } },
              y: {
                ticks: {
                  font: (ctx) => {
                    const name = sorted[ctx.index]?.name;
                    const isFiltered = hasFilter && filteredNames.has(name);
                    return {
                      size: isFiltered ? 18 : 12,
                      weight: isFiltered ? 'bold' : 'normal',
                    };
                  },
                  color: (ctx) => {
                    const name = sorted[ctx.index]?.name;
                    const isFiltered = hasFilter && filteredNames.has(name);
                    return isFiltered ? PRIMARY_COLOR : '#666';
                  },
                },
                grid: { display: false },
              },
            },
          }}
        />
      </div>
    </div>
  );
};

export default MetricBar;
